export default "__VITE_ASSET__eca0efc6__"